import { BonificoDTO } from "../../models/bonifico-dto";
import { BonificoExtraSepaDTO } from "../../models/bonifico-extra-sepa-dto";
import { ModalitaPagamentoDTO } from "../../models/modalita-pagamento-dto";
import { TesoreriaDTO } from "../../models/tesoreria-dto";
import { VagliaBdiDTO } from "../../models/vaglia-bdi-d-t-o";

export function toBonificoSepa(modalitaPagamento: ModalitaPagamentoDTO): BonificoDTO {
	const bonificoSepa = new BonificoDTO();
	bonificoSepa.iban = modalitaPagamento.conto;
	return bonificoSepa;
}

export function toTesoreria(modalitaPagamento: ModalitaPagamentoDTO): TesoreriaDTO {
	const tesoreria = new TesoreriaDTO();
	tesoreria.numeroConto = modalitaPagamento.conto;
	tesoreria.tesoreria = modalitaPagamento.tesoreria.codice;
	return tesoreria;
}

export function toBonificoExtraSepa(modalitaPagamento: ModalitaPagamentoDTO): BonificoExtraSepaDTO {

	console.log('[toBonificoExtraSepa]', modalitaPagamento);

	const bonificoExtraSepa = new BonificoExtraSepaDTO()
	bonificoExtraSepa.indirizzo = modalitaPagamento.indirizzo;
	bonificoExtraSepa.istitutoBancario = modalitaPagamento.denominazione;
	//TODO
	// bonificoExtraSepa.localita = modalitaPagamento.
	// bonificoExtraSepa.nazione = (modalitaPagamento.nazione || {}).codiceCatastale;
	bonificoExtraSepa.nazione = modalitaPagamento.nazione;
	bonificoExtraSepa.numeroConto = modalitaPagamento.conto + " " + modalitaPagamento.swiftBic;
	return bonificoExtraSepa;
}

export function toVagliaBdi(modalitaPagamento: ModalitaPagamentoDTO): VagliaBdiDTO {
	const vaglia = new VagliaBdiDTO();
	vaglia.meMedesimo = true;
	vaglia.studioLegale = false;
	return vaglia;
}